import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3bff9256")

_pushScopeId("data-v-3bff9256")
const _hoisted_1 = {
  key: 0,
  class: "material-icons spin"
}
const _hoisted_2 = {
  key: 1,
  class: "errorScreen"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "warning"),
  /*#__PURE__*/_createTextVNode(" Something went wrong")
], -1)
const _hoisted_4 = { class: "action-row" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Close", -1)
const _hoisted_7 = {
  key: 2,
  class: "infoScreen"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "info", -1)
const _hoisted_9 = { class: "action-row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Okay", -1)
const _hoisted_11 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: "loadingPrompt",
    style: {
      display:
        _ctx.loading.loading || _ctx.loading.error || _ctx.loading.info ? 'flex' : 'none'
    }
  }, [
    (_ctx.loading.loading)
      ? (_openBlock(), _createBlock("span", _hoisted_1, " autorenew "))
      : (_ctx.loading.error)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("p", null, _toDisplayString(_ctx.loading.error), 1),
            _createVNode("div", _hoisted_4, [
              (_ctx.loading.action)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "btn action",
                    onClick: _cache[1] || (_cache[1] = $event => {
            _ctx.loading.error = null;
            _ctx.loading.action.callback();
          })
                  }, [
                    _createVNode("span", _hoisted_5, _toDisplayString(_ctx.loading.action.label), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: "btn close",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.loading.error = null))
              }, [
                _hoisted_6
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("p", null, [
              _hoisted_8,
              _createVNode("span", {
                innerHTML: _ctx.loading.info
              }, null, 8, ["innerHTML"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", {
                class: "btn close",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.loading.info = null))
              }, [
                _hoisted_10
              ]),
              (_ctx.loading.action)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "btn action",
                    onClick: _cache[4] || (_cache[4] = $event => {
            _ctx.loading.info = null;
            _ctx.loading.action.callback();
          })
                  }, [
                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.loading.action.label), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
  ], 4))
})